import {memo} from 'react';
import Menu from "./Menu";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    ListItem,
    ListItemPrefix,
    Typography
} from "@material-tailwind/react";
import {MenuItemProps} from "./MenuItem";
import {isDarkMode} from "../../App";

interface MenuAccordionProps {
    index: number,
    isActive: boolean,
    setActive: (index: number) => void,
    name: string,
    list: MenuItemProps[],
    icon?: JSX.Element
}
const MenuAccordion = ({isActive, setActive, list, name, icon, index}: MenuAccordionProps) => {
    return (
        <Accordion
            open={isActive}
            icon={
                <FontAwesomeIcon className={`w-4 h-4 dark:text-gray-500 transition-transform mx-auto ${isActive ? "rotate-180" : ""}`} icon={solid("chevron-down")} />
            }
        >
            <ListItem className="p-0" selected={isActive}>
                <AccordionHeader onClick={() => setActive(index)} className="border-b-0 p-3 dark:focus:bg-blue-gray-900 dark:active:bg-blue-gray-900 dark:hover:bg-blue-gray-900 dark:bg-blue-gray-900">
                    {icon && <ListItemPrefix>{icon}</ListItemPrefix>}
                    <Typography color={isDarkMode? 'gray': 'blue-gray'} className="mr-auto font-normal text-gray-900 dark:text-gray-500">
                        {name}
                    </Typography>
                </AccordionHeader>
            </ListItem>
            <AccordionBody className="py-1">
                <Menu className="p-0 text-gray-900 dark:text-gray-500" list={list} />
            </AccordionBody>
        </Accordion>
    );
}

export default memo(MenuAccordion)
